import { render, staticRenderFns } from "./ModifierGroup.vue?vue&type=template&id=27f7062c"
import script from "./ModifierGroup.vue?vue&type=script&lang=js"
export * from "./ModifierGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports